import { Layers } from '@modules/core';
import { getDeviceInfo } from '@modules/standard/src/util/DeviceInfo';
import { CSSProperties, forwardRef, memo, ReactNode } from 'react';

import { GuiResponse } from '../ecs/component/response/GUI';


export const getItemStyle = ({
  x,
  y,
  scaleWithCameraDistance,
  zIndex,
}: {
  x: number;
  y: number;
  scaleWithCameraDistance: number;
  zIndex: number;
}): CSSProperties => {
  let scale = 1;
  if (scaleWithCameraDistance) {
    const isWide = !getDeviceInfo().isMobileOrTablet && window.innerWidth > 360;
    scale = isWide ? scaleWithCameraDistance + 1 : 0.5 * scaleWithCameraDistance + 1;
  }

  return {
    position: 'absolute',
    textAlign: 'center',
    padding: '0px',
    transform: `translate(-50%, -50%) scale(${scale})`,
    left: `${x}px`,
    top: `${y}px`,
    zIndex: `${zIndex}`,
  };
};

export const preUpdateGUI = <T extends GuiResponse>(elem: HTMLElement | null, item: T) => {
  if (!elem) return;

  const newStyle = getItemStyle({
    x: item.x,
    y: item.y,
    scaleWithCameraDistance: item.iconScaleOffset,
    zIndex: item.zIndex,
  });
  elem.style.left = newStyle.left?.toString()!;
  elem.style.top = newStyle.top?.toString()!;
  elem.style.transform = newStyle.transform?.toString()!;
};

const _GUIView = forwardRef(function CommonGUIView({ children }: { children?: ReactNode }, _ref) {
  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'none',
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: Layers.BABYLON_CANVAS,
      }}>
      {children}
    </div>
  );
});

export const GUIView = memo(_GUIView);

